module.exports = __webpack_public_path__ + "static/img/202103151625511.58bcf48.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/inspectionImg/20210315/202103151625511.jpg
// module id = 7COS
// module chunks = 11